import { MINIMIZED_MODAL_KEY } from '../../Modal'

export const USER_PROFILE_MODALS_CONFIG = {
  setEmailFormModal: {
    closer: 'closeEmailFormModal',
    id: MINIMIZED_MODAL_KEY.EMAIL_FORM,
  },
}
